import { ADD_ERROR_LOG } from '../mutation-types'
const state = {
  logs: [],
}
const mutations = {
  [ADD_ERROR_LOG](state, log) {
    state.logs.push(log)
  },
}

export default {
  state,
  mutations,
}
